<template>
  <div class="data-center-page">
    <p class="bread-tab">
      <span>数据中心/</span>
      <span class="bd">{{ tabName }}</span>
    </p>
    <router-view></router-view>
  </div>
</template>

<script>
import { TABNAMES } from "./constants";
export default {
  name: "DataCenter",
  data() {
    return {};
  },
  computed: {
    tabName() {
      return TABNAMES[this.$route.path];
    },
  },
};
</script>

<style scoped>
.bread-tab {
  font-size: 16px;
}
.bd {
  font-weight: bold;
}
</style>
<style lang="less">
.data-center-page {
  .el-table {
    th,
    td {
      padding: 12px 10px;
    }
    td {
      word-break: break-word;
    }
    .cell {
      padding: 0px;
      line-height: normal;
    }
  }
}
</style>
